export default __webpack_public_path__ + "static/media/moneydestroyer.1a343d98.jpg";